import React, { useEffect, useState } from 'react'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import ProcessController from "../components/process-controller"
import ImagesUploader from "../components/images-uploader"
import { handleImageUrl } from "../helpers";
import TextEditor from "../components/text-editor"
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'
import {axios} from "../axios"
import FormControl from "@mui/material/FormControl"
import {Select} from "@mui/material"
import MenuItem from "@mui/material/MenuItem"
import {useNavigate, useParams} from "react-router-dom"

// Existing uploads keep their stored path (sent back as existing_*) apart from the display URL
const fileUrlsToUploaderData = (paths)=>{
    return (paths || []).filter(p => p && p !== 'none_images').map(path => ({
        path,
        url: handleImageUrl(path),
    }))
}

const EditApartment = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [formData,setFormData] = useState({
        title_en:'',
        title_de:'',
        address_en:'',
        address_de:'',
        city_en:'',
        city_de:'',
        country_en:'',
        country_de:'',
        region_id: '',
        stars:'',
        description_en:'',
        description_de:'',
        key_words_en:'',
        key_words_de:'',
        text_en:'',
        text_de:'',
        images:[],
        thumbnail:[],
    })
    const [section, setSection] = React.useState('1');
    const [submitProcess,setSubmitProcess] = useState('none')
    const [errors,setErrors] = useState([])
    const [region,setRegion] = useState([])

    const handleChange = (name,value)=>{
        setFormData({...formData,[name]: value})
    }
    const handleSection = (event, newValue) => {
        setSection(newValue);
    };
    const validateForm = ()=>{
        if(!(formData.title_en || '').trim()){
            setErrors(['title_en']);
            return false;
        }
        setErrors([]);
        return true;
    }
    const textLengthValidate = () => {
        let errorsList = []
        if(formData.title_en.length > 60){ errorsList.push('title_en') }
        if(formData.title_de.length > 60){ errorsList.push('title_de'); setSubmitProcess('text length error') }
        if(formData.description_en.length > 160){ errorsList.push('description_en'); setSubmitProcess('text length error') }
        if(formData.description_de.length > 160){ errorsList.push('description_de'); setSubmitProcess('text length error') }
        setErrors(errorsList)
        return errorsList.length === 0;
    }

    useEffect(()=>{
        setSubmitProcess('load')
        const fetchBothLangs = async () => {
            try {
                const reqEn = axios.get(`en/apartment/${params.id}`).catch(() => axios.get(`/apartment/${params.id}?lang=en`))
                const reqDe = axios.get(`de/apartment/${params.id}`).catch(() => axios.get(`/apartment/${params.id}?lang=de`))
                const [resEn, resDe] = await Promise.all([reqEn, reqDe])
                const dEn = resEn?.data || {}
                const dDe = resDe?.data || {}
                setFormData(prev => ({
                    ...prev,
                    title_en: dEn.title_en || dEn.title || '',
                    title_de: dDe.title_de || dDe.title || '',
                    description_en: dEn.description_en ?? dEn.description ?? '',
                    description_de: dDe.description_de ?? dDe.description ?? '',
                    country_en: dEn.country_en ?? dEn.country ?? '',
                    country_de: dDe.country_de ?? dDe.country ?? '',
                    address_en: dEn.address_en ?? dEn.address ?? '',
                    address_de: dDe.address_de ?? dDe.address ?? '',
                    city_en: dEn.city_en ?? dEn.city ?? '',
                    city_de: dDe.city_de ?? dDe.city ?? '',
                    region_id: dEn.region_id ?? dDe.region_id ?? '',
                    stars: dEn.stars ?? dDe.stars ?? '',
                    key_words_en: (dEn.key_words_en ?? dEn.keywords_en ?? dEn.key_words ?? dEn.keywords ?? ''),
                    key_words_de: (dDe.key_words_de ?? dDe.keywords_de ?? dDe.key_words ?? dDe.keywords ?? ''),
                    text_en: dEn.text_en ?? dEn.text ?? '',
                    text_de: dDe.text_de ?? dDe.text ?? '',
                }))
                // Images/thumbnail
                const thumb = dEn.thumbnail ?? dDe.thumbnail
                if (thumb) {
                    const thumbArr = Array.isArray(thumb) ? thumb : String(thumb).split(',').filter(Boolean)
                    setFormData(f => ({...f, thumbnail: fileUrlsToUploaderData(thumbArr)}))
                }
                const imgs = dEn.images ?? dDe.images
                if (imgs) {
                    const imgsArr = Array.isArray(imgs) ? imgs : String(imgs).split(',').filter(Boolean)
                    setFormData(f => ({...f, images: fileUrlsToUploaderData(imgsArr)}))
                }
                setSubmitProcess('none')
            } catch (e) {
                setSubmitProcess('none')
            }
        }
        fetchBothLangs()
        axios.get(`${process.env.REACT_APP_LOCAL_API}region`)
            .then(res=>setRegion(res.data))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[params.id])

    const handleSubmit = ()=>{
        if(!validateForm()){ setSubmitProcess('error'); return false }
        if(!textLengthValidate()){ setSubmitProcess('error-text-length'); return false }
        setSubmitProcess('load')
        let fd = new FormData()
        fd.append('title_en',formData.title_en)
        fd.append('title_de',formData.title_de)
        fd.append('description_en',formData.description_en)
        fd.append('description_de',formData.description_de)
        fd.append('country_en',formData.country_en)
        fd.append('country_de',formData.country_de)
        fd.append('address_en',formData.address_en)
        fd.append('address_de',formData.address_de)
        fd.append('city_en',formData.city_en)
        fd.append('city_de',formData.city_de)
        fd.append('region_id',formData.region_id)
        fd.append('stars',formData.stars)
        // backend expects keywords_*
        fd.append('keywords_en',formData.key_words_en)
        fd.append('keywords_de',formData.key_words_de)
        fd.append('text_en',formData.text_en)
        fd.append('text_de',formData.text_de)
        // Managed sets: the API keeps existing_images[] that are still shown, adds the new
        // images[] and deletes only what was removed
        fd.append('images_managed', '1')
        const imageItems = formData.images || []
        imageItems.forEach(el => {
            if (el.file) fd.append('images[]', el.file)
            else if (el.path) fd.append('existing_images[]', el.path)
        })
        fd.append('thumbnail_managed', '1')
        const thumbItem = (formData.thumbnail || [])[0]
        if (thumbItem?.file) fd.append('thumbnail', thumbItem.file)
        else if (thumbItem?.path) fd.append('existing_thumbnail', thumbItem.path)
        axios.post(`/apartment/${params.id}`,fd)
            .then(res => {
                if(res.data === 'updated' || res.data?.message === 'updated'){
                    setSubmitProcess('updated')
                }else{
                    setSubmitProcess('error')
                }
            })
            .catch(()=> setSubmitProcess('error'))
    }

    const handleDelete = ()=>{
        // eslint-disable-next-line no-restricted-globals
        const c = confirm('Delete this apartment?')
        if(!c) return
        setSubmitProcess('load')
        axios.delete(`/apartment/${params.id}`)
            .then(res=>{
                if(res.data?.message === 'deleted' || res.status === 200){
                    alert('Deleted successfully')
                    navigate('/apartment')
                }else{
                    setSubmitProcess('error')
                }
            })
            .catch(()=> setSubmitProcess('error'))
    }

    return (
        <div className='main-container'>
            <ProcessController
                entity='Apartment'
                setSubmitProcess={setSubmitProcess}
                submitProcess={submitProcess}
                locationPath='/apartment'
                handleSubmit={handleSubmit}/>
            <div className='container mt-3'>
                <div className='d-flex justify-content-end'>
                    <button className='btn btn-danger' onClick={handleDelete}>Delete</button>
                </div>
            </div>
            <TabContext  value={section}>
                <Box sx={{ borderBottom: 1, borderColor: 'black',backgroundColor:'#0a5f9d',color:"white" }}>
                    <TabList onChange={handleSection} aria-label="lab API tabs example" >
                        <Tab label="SEO" value="1" style={{color:'white'}}/>
                        <Tab label="Details" value="3" style={{color:'white'}}/>
                        <Tab label="Images" value="5" style={{color:'white'}}/>
                    </TabList>
                </Box>
                <div className="add-post mt-3 form">
                    <div className="container">
                        <TabPanel value="1" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container require ${errors.includes('title_en') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Title *</h6>
                                        <input  value={formData.title_en} onChange={e => handleChange('title_en',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container require ${errors.includes('title_de') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Title (German) *</h6>
                                        <input  value={formData.title_de} onChange={e => handleChange('title_de',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className={`col-6 require ${errors.includes('description_en') ? 'error' : ''}`}>
                                    <div className='text-editor'>
                                        <h6 className='title-label'>Description *</h6>
                                        <textarea
                                            rows='6'
                                            placeholder='max length 120 letters'
                                            onChange={ e => handleChange('description_en', e.target.value)} value={formData.description_en}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className={`col-6 require ${errors.includes('description_de') ? 'error' : ''}`}>
                                    <div className='text-editor'>
                                        <h6 className='title-label'>Description (German) *</h6>
                                        <textarea
                                            rows='6'
                                            placeholder='max length 120 letters'
                                            onChange={ e => handleChange('description_de', e.target.value)} value={formData.description_de}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require ${errors.includes('key_words_en') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Key Words *</h6>
                                        <input
                                            value={formData.key_words_en}
                                            onChange={ e => handleChange('key_words_en', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters'}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require ${errors.includes('key_words_de') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Key Words (German) *</h6>
                                        <input
                                            value={formData.key_words_de}
                                            onChange={ e => handleChange('key_words_de', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="3" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className={`col-6 require ${errors.includes('text_en') ? 'error' : ''}`}>
                                    <TextEditor value={formData.text_en} handleChange={handleChange} name='text_en' title='Text *'/>
                                </div>
                                <div className={`col-6 require ${errors.includes('text_de') ? 'error' : ''}`}>
                                    <TextEditor value={formData.text_de} handleChange={handleChange} name='text_de' title='Text (German) *'/>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container`}>
                                        <h6 className='title-label'>Address</h6>
                                        <input  value={formData.address_en} onChange={e => handleChange('address_en',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container`}>
                                        <h6 className='title-label'>Address (German)</h6>
                                        <input  value={formData.address_de} onChange={e => handleChange('address_de',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container`}>
                                        <h6 className='title-label'>Country</h6>
                                        <input  value={formData.country_en} onChange={e => handleChange('country_en',e.target.value)} type="text"/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container`}>
                                        <h6 className='title-label'>Country (German)</h6>
                                        <input  value={formData.country_de} onChange={e => handleChange('country_de',e.target.value)} type="text" />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container`}>
                                        <h6 className='title-label'>City</h6>
                                        <input  value={formData.city_en} onChange={e => handleChange('city_en',e.target.value)} type="text"/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container`}>
                                        <h6 className='title-label'>City (German)</h6>
                                        <input  value={formData.city_de} onChange={e => handleChange('city_de',e.target.value)} type="text" />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Region</h6>
                                        <FormControl fullWidth>
                                            <Select
                                                value={formData.region_id}
                                                label="Regions"
                                                onChange={e => handleChange('region_id',e.target.value)}
                                            >
                                                {region.map(e => <MenuItem key={e.id} value={e.id}>{e.title_en}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container`}>
                                        <h6 className='title-label'>Stars</h6>
                                        <input  value={formData.stars} onChange={e => handleChange('stars',e.target.value)} type="text"/>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="5">
                            <div className="row mb-3">
                                <div className={`col-6`}>
                                    <ImagesUploader data={formData.thumbnail} handleImages={handleChange} name='thumbnail' title='Thumbnail' multiple={false}/>
                                </div>
                                <div className={`col-6`}>
                                    <ImagesUploader data={formData.images} handleImages={handleChange} name='images' title='Images' multiple={true}/>
                                </div>
                            </div>
                        </TabPanel>
                    </div>
                </div>
            </TabContext>
        </div>
    );
};

export default EditApartment;
